import { PVP_DETONATE_KEY } from '../pvp/controls';
import { BLEED_BURST_GLYPH } from './bleed-glyph';

/**
 * **A tecla, DERIVADA da que está ligada.**
 *
 * `PVP_DETONATE_KEY` é um `code` do teclado (`Digit1`), e o que se imprime é o
 * algarismo. Derivar em vez de escrever `1` é o que impede o botão de anunciar
 * uma tecla que já não é a que funciona: mudar a ligação move o rótulo com ela,
 * e uma ligação que deixe de ser um algarismo aparece aqui em vez de mentir.
 */
export const PVP_DETONATE_KEY_LABEL = PVP_DETONATE_KEY.startsWith('Digit')
  ? PVP_DETONATE_KEY.slice('Digit'.length)
  : PVP_DETONATE_KEY;

/**
 * **O rótulo do botão que rompe as marcas** (gate V28G.N).
 *
 * Um componente e não duas cópias de JSX: o duelo e o 3x3 mostram exatamente o
 * mesmo botão, e dois rótulos escritos à mão são dois sítios onde o símbolo, o
 * separador ou a contagem podem passar a discordar.
 *
 * ## 破, e porquê ele
 *
 * *Ha* - romper, rasgar. É a AÇÃO, e não o estado: a marca no inimigo é 傷
 * (ferida), e este botão não mostra uma ferida, mostra o ato de a abrir. Um só
 * carácter para as duas coisas apagaria a distinção que este gate assenta.
 *
 * `aria-hidden` no símbolo, deliberadamente: um leitor de ecrã que anunciasse
 * "破" a quem não lê japonês diria menos do que o texto ao lado já diz.
 *
 * ## E a tecla, ESCRITA no botão
 *
 * O `1` existe desde que o dono o pediu, e um atalho que só existe no código é
 * um atalho que ninguém usa. Fica no rótulo, com a forma de uma tecla, para o
 * botão dizer sozinho como se dispensa o rato.
 *
 * Anunciado ao leitor de ecrã, ao contrário do kanji: "tecla 1" é informação
 * inteira e útil a quem não vê o desenho.
 */
export function BleedButtonLabel({ marks }: { readonly marks: number }) {
  return (
    <>
      <span className="pvp-hud-detonate-glyph" aria-hidden="true">
        {BLEED_BURST_GLYPH}
      </span>
      <span className="pvp-hud-detonate-text">DETONAR ×{marks}</span>
      <kbd className="pvp-hud-detonate-key">{PVP_DETONATE_KEY_LABEL}</kbd>
    </>
  );
}
